/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-datalabels-font-size',
  templateUrl: './theme-option-datalabels-font-size.component.html',
  styleUrls: ['./theme-option-datalabels-font-size.component.css']
})
export class ThemeOptionDatalabelsFontSizeComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() datalabelsIndex: number;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'datalabels_fontSize';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: number, type?: ChartType) {
    this.themeOptions.setDatalabels(this.optionType, value, this.datalabelsIndex, type ? [type] : undefined);
  }

}
